/**
 *
 * @readonly
 * @enum {string}
 */
module.exports = {
    FREE_TARIFF_LECTURES_LIMIT: 8,
    FREE_TARIFF_BOOKING_COUNT_LIMIT: 25,
    LITE_TARIFF_BOOKING_COUNT_LIMIT: 50,
    PROFESSIONAL_TARIFF_BOOKING_COUNT_LIMIT: 150,
    EXPERT_TARIFF_BOOKING_COUNT_LIMIT: 700,
    LITE_TARIFF_COURSES_COUNT: 1,
    LITE_TARIFF_WORKSHOPS_COUNT: 3,
    PROFESSIONAL_TARIFF_COURSES_COUNT: 5,
    UNLIMITED_ORDERS_CONSTANT: 9999,
    TRIAL_TARIFF_DAYS_DURATION: 14,
};
